import api from "../api";

export const getFirmwareVersion = async () => {
    try {
        const response = await api.get(`mivulite/firmware/version`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getFirmwareReleases = async () => {
    try {
        const response = await api.get(`mivulite/firmware/releases`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getFirmwareHistory = async (device_id) => {
    try {
        const response = await api.get(`mivulite/firmware/history/${device_id}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const updateFirmwareRelease = async (id, data) => {
    try {
        const response = await api.put(`mivulite/firmware/releases/${id}`, data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const deleteFirmwareRelease = async (id) => {
    try {
        const response = await api.delete(`mivulite/firmware/releases/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const uploadFirmware = async (formData) => {
    try {
        const response = await api.post(`mivulite/firmware/upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getBootloaderBinary = async (device_type) => {
    try {
        const response = await api.get(`mivulite/flash/bootloader/${device_type}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getFlashDevices = async () => {
    try {
        const response = await api.get(`mivulite/flash/devices`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getFlashFirmwareBinary = async (device_type) => {
    try {
        const response = await api.get(`mivulite/flash/firmware/${device_type}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const serveFirmwareFile = async (file) => {
    try {
        const response = await api.get(`mivulite/flash/firmware/${file}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getFlashManifest = async () => {
    try {
        const response = await api.get(`mivulite/flash/manifest`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getPartitionTable = async (device_type) => {
    try {
        const response = await api.get(`mivulite/flash/partition-table/${device_type}`);
        return response.data;
    } catch (error) {
        console.error(error);
    }
};